import React from 'react';
import PropTypes from 'prop-types';
import Checkbox from 'material-ui/Checkbox';
import { FormattedNumber } from 'react-intl';
import ChargeRow from 'chargeComponents/ChargeRow';
import ChargeCommentTextBox from 'chargeComponents/ChargeCommentTextBox';
class ChargeCheckbox extends React.Component {

    constructor(props) {
        super(props);
        this.onCheck = this
            .onCheck
            .bind(this);
    }

    onCheck(e, checked) {

        const { charge, chargeActions, orderId } = this.props;

        if (checked) {
            chargeActions.chargeQuantitySet(charge.get('chargeID'), 1, orderId);
        } else {
            chargeActions.chargeQuantitySet(charge.get('chargeID'), 0, orderId);
        }
    }

    render() {

        const { charge, disabled, orderId, chargeActions } = this.props;
        if (!charge) {
            return null;
        }

        const checked = charge.get('quantity') === 1;

        const label = (<FormattedNumber value={charge.get('cost')} style="currency" currency="USD" />);

        const checkBox = (<Checkbox
            labelStyle={{
                textAlign: 'right',
                paddingRight: '15px'
            }}
            labelPosition="left"
            disabled={disabled}
            defaultChecked={checked}
            onCheck={this.onCheck}
            label={label} />);

        let commentInput = null;

        if (charge.get('requiresComment') && charge.get('quantity') > 0) {
            commentInput = (<ChargeCommentTextBox
                hasUnsavedChanges={charge.get('hasUnsavedChanges')}
                charge={charge}
                disabled={disabled}
                orderId={orderId}
                chargeActions={chargeActions} />);
        }

        return (<ChargeRow
            hasUnsavedChanges={charge.get('hasUnsavedChanges')}
            title={charge.get('description')}
            option={checkBox}
            commentInput={commentInput}
            loading={charge.get('loading')}
            error={charge.get('error')}
            message={charge.get('message')} />);
    }
}

ChargeCheckbox.propTypes = {
    charge: PropTypes.object,
    chargeActions: PropTypes.object,
    orderId: PropTypes.string,
    disabled: PropTypes.bool

};
export default ChargeCheckbox;


// WEBPACK FOOTER //
// ./src/components/charges/ChargeCheckbox.js